module.exports = __webpack_public_path__ + "img/follow-initiative.fcb6db30.svg";